import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useStyle } from "./style";

interface IParams {
    icon: ReactNode;
    text: string;
    linkComponent?: ReactNode;
}

export const IconInfos = (props: IParams) => {
    const { icon, text, linkComponent } = props;
    const { classes } = useStyle();

    return (
        <div className={classes.container}>
            <div className={classes.iconTextContainer}>
                <div className={classes.icon}>{icon}</div>
                <Typography variant="normal">{text}</Typography>
            </div>
            {linkComponent && <Box paddingRight={2}>{linkComponent}</Box>}
        </div>
    );
};
